import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export function useSetRef(initialValue) {
    const value = React.useRef(null);
    value.current = initialValue;
    return value;
}
export function Transition(props) {
    const { duration = 250, easing = "ease", from, to, children, show, fill = "none", purpose } = props;
    const ref = React.useRef(null);
    const nodeRef = useSetRef(props.nodeRef);
    const animationNode = React.useRef();
    const mutationsRef = React.useRef();
    const keyframes = React.useMemo(() => {
        return [from, to];
    }, [from, to]);
    const handleMutations = React.useCallback((mutations, observer) => {
        if (mutations.length !== 1)
            return;
        const mutation = mutations[0];
        const addedNode = mutation.addedNodes[0];
        const removedNode = mutation.removedNodes[0];
        if (addedNode?.dataset["removed"] === "true")
            return;
        if (removedNode?.dataset["removed"] === "true")
            return;
        if (addedNode) {
            if (nodeRef.current && !addedNode.contains(nodeRef.current))
                return;
            animationNode.current = nodeRef.current;
            const nodeToAnimate = nodeRef.current ?? addedNode;
            const inDuration = typeof duration === "number" ? duration : duration.in;
            const effect = new KeyframeEffect(nodeToAnimate, keyframes, { duration: inDuration, easing, fill });
            const animation = new Animation(effect);
            animation.play();
        }
        else if (removedNode) {
            if (animationNode.current && !removedNode.contains(animationNode.current))
                return;
            ref.current?.appendChild(removedNode);
            removedNode.dataset["removed"] = "true";
            const nodeToAnimate = animationNode.current ?? removedNode;
            const outDuration = typeof duration === "number" ? duration : duration.out;
            const effect = new KeyframeEffect(nodeToAnimate, keyframes, { duration: outDuration, easing, direction: "reverse" });
            const animation = new Animation(effect);
            animation.onfinish = () => {
                removedNode.remove();
                animationNode.current = null;
                props.onExited?.();
            };
            animation.play();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [duration, easing]);
    React.useEffect(() => {
        const element = ref.current;
        if (!element)
            return;
        mutationsRef.current = new MutationObserver(handleMutations);
        const mutationObserver = mutationsRef.current;
        mutationObserver.observe(element, { childList: true });
        return () => {
            mutationObserver.disconnect();
        };
    }, [handleMutations]);
    return _jsx("div", { ref: ref, style: { display: "contents" }, "data-purpose": purpose, children: show ? children : null });
}
